/* global Promise */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class HiddenInteractionPlaceholder extends React.Component {
    static propTypes = {
        onReady: PropTypes.func.isRequired, // callback(responseIdentifier, [simpleChoice identifiers])
    };

    componentDidMount() {
        this.props.onReady();
    }

    render() {
        return <div className="hidden-interaction" />;
    }
}

export default async function showHiddenInteractionPlaceholder(interactionModel) {
    return new Promise((resolve, reject) => {
        const onReady = () => {
            resolve();
        };

        const interactionTarget = document.getElementById(interactionModel.target);
        if (!interactionTarget) {
            return reject(`Missing render target ${interactionModel.target} in DOM for interaction. Displaying error page`);
        }

        ReactDOM.render(
            <HiddenInteractionPlaceholder onReady={onReady} />,
            interactionTarget,
        );
        return true;
    });
}
